import { useEffect, useRef, useState } from 'react';
import Dialog from 'components/Overlays/AnimatedDialog';
import { FiLoader, FiTrash2 } from 'react-icons/fi';
import useDeleteExceptions from 'api/Exceptions/useDeleteExceptions';

export default function BulkDeleteDialog({ exceptionIds, visible, onHide, onDeleted, onExited }) {
    const { mutateAsync, isLoading } = useDeleteExceptions();
    const [pending, setPending] = useState(false);
    const [error, setError] = useState('');
    const lock = useRef(false);
    const mounted = useRef(true);
    useEffect(() => () => { mounted.current = false; }, []);
    const count = exceptionIds.length;
    const busy = isLoading || pending;
    const remove = async () => {
        if (!visible || lock.current || !count) return;
        lock.current = true; setPending(true); setError('');
        try { await mutateAsync(exceptionIds); }
        catch (failure) {
            lock.current = false;
            if (mounted.current) { setPending(false); setError(failure?.response?.data?.message || 'Couldn’t delete these reports. Please try again.'); }
            return;
        }
        lock.current = false;
        if (mounted.current) { setPending(false); onDeleted(); }
    };
    return <Dialog visible={visible} onExited={onExited} modal blockScroll draggable={false} resizable={false} className="error-delete-dialog"
        header={count === 1 ? 'Delete error report?' : 'Delete error reports?'} onHide={() => { if (!busy) onHide(); }} closable={!busy} closeOnEscape={!busy}
        footer={<><button type="button" className="portal-button" disabled={busy} onClick={onHide}>Cancel</button><button type="button" className="portal-button error-delete-primary" disabled={busy || !count} onClick={remove}>{busy ? <FiLoader className="error-spin" aria-hidden="true" /> : <FiTrash2 aria-hidden="true" />}{busy ? 'Deleting…' : `Delete ${count} ${count === 1 ? 'report' : 'reports'}`}</button></>}>
        <p>{count} {count === 1 ? 'report will' : 'reports will'} be permanently deleted. This action cannot be undone.</p>
        <p className="error-delete-note">Deleting a report removes its record. It does not fix the underlying error.</p>
        {error && <p className="error-delete-error" role="alert">{error}</p>}
    </Dialog>;
}
